module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "重置密码"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "recordForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.recordRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "新密码",
      "prop": "recordingContent"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAdd
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("确定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c221a49","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lesson/modal/ResetPassWordModal.vue
// module id = 1723
// module chunks = 8